import { FC } from 'react';

import { Button } from 'antd';
import { motion } from 'framer-motion';

import { useTranslation } from 'react-i18next';
import { standardAnimationProps } from '../../../constants/animations';
import styles from './PendingConfirmation.module.scss';

interface PendingConfirmationProps {
  onCancelClick: () => void;
}

const PendingConfirmation: FC<PendingConfirmationProps> = ({
  onCancelClick
}) => {
  const { t } = useTranslation()

  return <motion.div {...standardAnimationProps}>
    <h2 className={styles.title}>{t('sidebar.application.interview.awaitingResponse.title')}</h2>

    <Button type="text" onClick={onCancelClick} className={styles.cancelButton}>
      {t('sidebar.application.interview.awaitingResponse.cancel')}
    </Button>
  </motion.div>
};

export default PendingConfirmation;
